import { useEffect, useState } from 'react';
import api from '@/lib/axios';

let _cache = null;

export function fetchLegalSettings() {
  if (!_cache) {
    _cache = api
      .get('/marketplace/legal-settings')
      .then((r) => r.data)
      .catch(() => ({}));
  }
  return _cache;
}

// Hook para obter as definições legais (empresa, RAL, marca) da BD.
export function useLegalSettings() {
  const [legal, setLegal] = useState(null);
  useEffect(() => {
    let alive = true;
    fetchLegalSettings().then((d) => {
      if (alive) setLegal(d || {});
    });
    return () => {
      alive = false;
    };
  }, []);
  return legal;
}
